import axios from 'axios'
import * as common from './common'

/**
 * 优惠券服务API封装
 */
export class CouponService {
  /**
   * 根据车牌号查询优惠券列表
   * @param {object} params - 查询参数
   * @param {string} params.sid - 会话ID
   * @param {string} params.vh_p_number - 车牌号
   * @param {number} params.page_no - 页码
   * @param {number} params.page_size - 每页大小
   * @param {number} params.status - 状态
   * @returns {Promise<object>} API响应数据
   */
  static async getCouponListByVehicle(params) {
    try {
      const { data } = await axios({
        url: common.couponUrl + 'enterprise.coupon.list_by_vh',
        method: 'POST',
        data: {
          v: '1.0',
          app_key: 'd7ca0abc-6b4b-44e4-bc71-7fd329ce2f7a',
          app_pass: '17f6e649-d26f-488f-b03b-5676aa3be362',
          sid: params.sid,
          vh_p_number: params.vh_p_number,
          page_no: params.page_no || 1,
          page_size: params.page_size || 1000,
          status: params.status || 1
        },
        header: {
          'content-type': 'application/json'
        }
      })
      return data
    } catch (e) {
      throw e
    }
  }

  /**
   * 优惠券发放
   * @param {object} params - 发放参数
   * @returns {Promise<object>} API响应数据
   */
  static async deliverCoupon(params) {
    try {
      const { data } = await axios({
        url: common.couponUrl + 'enterprise.coupon.delivery',
        method: 'POST',
        data: params,
        header: {
          'content-type': 'application/json'
        }
      })
      return data
    } catch (e) {
      throw e
    }
  }

  /**
   * 查询优惠券规则信息
   * @param {object} params - 查询参数
   * @param {string} params.sid - 会话ID
   * @param {string} params.rule_id - 规则ID
   * @returns {Promise<object>} API响应数据
   */
  static async getCouponRuleInfo(params) {
    try {
      const { data } = await axios({
        url: common.couponUrl + 'enterprise.coupon.query_coupon_rule_info',
        method: 'POST',
        data: {
          v: '1.0',
          app_key: 'd7ca0abc-6b4b-44e4-bc71-7fd329ce2f7a',
          app_pass: '17f6e649-d26f-488f-b03b-5676aa3be362',
          sid: params.sid,
          rule_id: params.rule_id
        },
        header: {
          'content-type': 'application/json'
        }
      })
      return data
    } catch (e) {
      throw e
    }
  }

}
